import React from 'react';
import { Chip } from '@mui/material';
import {
  CAMPAIGN_STATUS_LABEL,
  DELIVERY_STATUS_LABEL,
  MailCampaignStatus,
  MailDeliveryStatus,
} from '../../hooks/useMailDelivery';

/** 配信の状態チップ (下書き / 予約 / 送信中 / 完了 / 中止 / 失敗) */
export function CampaignStatusChip({ status }: { status: MailCampaignStatus }) {
  const color: Record<MailCampaignStatus, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
    draft: 'default',
    scheduled: 'info',
    sending: 'warning',
    completed: 'success',
    cancelled: 'default',
    failed: 'error',
  };
  return <Chip size="small" label={CAMPAIGN_STATUS_LABEL[status] ?? status} color={color[status] ?? 'default'} variant={status === 'draft' || status === 'cancelled' ? 'outlined' : 'filled'} sx={{ fontSize: 11.5, height: 22 }} />;
}

/** 宛先の状態チップ */
export function DeliveryStatusChip({ status }: { status: MailDeliveryStatus }) {
  const color: Record<MailDeliveryStatus, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
    queued: 'default',
    sent: 'info',
    delivered: 'success',
    bounced: 'error',
    complained: 'error',
    failed: 'error',
    suppressed: 'warning',
  };
  return <Chip size="small" label={DELIVERY_STATUS_LABEL[status] ?? status} color={color[status] ?? 'default'} variant={status === 'queued' ? 'outlined' : 'filled'} sx={{ fontSize: 11.5, height: 22 }} />;
}
